import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    buttonContainer: {
        display: 'none',
        appearance: 'none',
        background: 'none',
        border: 'none',
        padding: '0px',
        margin: '0px',
        outline: 'none',
        '@media (max-width: 1024px)': {
            display: 'table-cell'
        }
    },
    content: {
        display: 'table-cell',
        height: '64px',
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: '0.25s color',
        paddingLeft: '24px',
        paddingRight: '24px',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap',
        '@media (min-width: 744px)': {
            height: '80px'
        }
    },
    icon: {
        color: '#FF5A5F',
        display: 'inline-block',
        verticalAlign: 'middle',
        fontSize: '34px',
        transition: '0.25s color'
    },
    iconWrapper: {
        display: 'table-cell',
        verticalAlign: 'middle',
        transitionProperty: '-ms-transform,-webkit-transform,transform',
        transitionDuration: '250ms',
        transitionTimingFunction: 'ease-in-out'
    },
    invisibleText: {
        position: 'absolute',
        top: 0,
        clip: 'rect(1px, 1px, 1px, 1px)',
        clipPath: 'inset(0px 0px 99.9% 99.9%)',
        overflow: 'hidden',
        height: '1px',
        width: '1px',
        padding: 0,
        border: 0,
        left: 'auto'
    },
    logo: {
        display: 'table-cell'
    },
    logoContainer: {
        position: 'relative',
        zIndex: 20
    },
    logoContainerLink: {
        display: 'none',
        outline: 'none',
        '@media (min-width: 1025px)': {
            display: 'table-cell'
        }
    },
    menuIndicator: {
        color: '#767676',
        display: 'table-cell',
        fontSize: '9px',
        paddingLeft: '8px',
        verticalAlign: 'middle',
        transition: '1s color',
        '@media (min-width: 1025px)': {
            display: 'none'
        },
        '@media (max-width: 744px)': {
            paddingLeft: '15px'
        }
    },
    zipcubeIcon: {
        display: 'inline-block',
        width: '30px',
        height: '30px',
        verticalAlign: 'middle'
    },
    zipcubeLogoSvg: {
        height: '50px',
        width: '110px',
        display: 'none',
        '@media (min-width: 744px)': {
            display: 'inline-block',
            verticalAlign: 'middle'
        }
    },
    zipcubeLogoSmallSvg: {
        height: '50px',
        width: '35px',
        display: 'none',
        '@media (max-width: 1024px)': {
            display: 'block'
        }
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/Header/Logo/styles.js